import React from 'react';
import { Box, Card, CardContent, Typography, Avatar } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

export default function StatCard({ title, value, subtitle, icon, color = '#2563eb', trend, small }) {
  const isPositive = trend === undefined ? null : trend >= 0;

  return (
    <Card sx={{
      height: '100%',
      borderRadius: 4,
      border: '1px solid #e2e8f0',
      boxShadow: '0 1px 3px 0 rgba(15, 23, 42, 0.04), 0 1px 2px -1px rgba(15, 23, 42, 0.04)',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -4px rgba(15, 23, 42, 0.04)'
      }
    }}>
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
          <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
            {title}
          </Typography>
          <Avatar sx={{ bgcolor: `${color}15`, width: 40, height: 40, borderRadius: 2.5 }}>
            <Box sx={{ color, '& svg': { fontSize: 20 } }}>{icon}</Box>
          </Avatar>
        </Box>
        <Typography variant={small ? 'h6' : 'h4'} sx={{ fontWeight: 800, color: color === 'auto' ? (isPositive ? '#10b981' : '#ef4444') : '#0f172a', letterSpacing: '-0.02em' }}>
          {value}
        </Typography>
        {subtitle && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
            {isPositive !== null && (isPositive
              ? <TrendingUp sx={{ fontSize: 14, color: '#10b981' }} />
              : <TrendingDown sx={{ fontSize: 14, color: '#ef4444' }} />
            )}
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>{subtitle}</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
